export default __webpack_public_path__ + "static/media/bike.fb41c762.svg";